(function () {
  "use strict";

  var EVENT_NAME = "interest_clicked";

  function getClosestInterestTarget(element) {
    if (!element || !element.closest) return null;
    return element.closest("[data-conversion-interest]");
  }

  function cleanValue(value) {
    return typeof value === "string" && value.length ? value : undefined;
  }

  function buildPayload(target) {
    var payload = {
      type:
        cleanValue(target.getAttribute("data-conversion-type")) || "unknown",
      source: cleanValue(target.getAttribute("data-conversion-source")),
      product_handle: cleanValue(target.getAttribute("data-product-handle")),
      variant_id: cleanValue(target.getAttribute("data-variant-id")),
      page_url: window.location.href,
    };

    Object.keys(payload).forEach(function (key) {
      if (
        payload[key] === undefined ||
        payload[key] === null ||
        payload[key] === ""
      ) {
        delete payload[key];
      }
    });

    return payload;
  }

  function publishInterest(payload) {
    if (
      !window.Shopify ||
      !window.Shopify.analytics ||
      typeof window.Shopify.analytics.publish !== "function"
    ) {
      return;
    }

    window.Shopify.analytics.publish(EVENT_NAME, payload);
  }

  document.addEventListener("click", function (event) {
    var target = getClosestInterestTarget(event.target);
    if (!target) return;
    if (target.getAttribute("aria-disabled") === "true" || target.disabled)
      return;

    publishInterest(buildPayload(target));
  });
})();
